'use client';

import { useMemo } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { Grid2, Stack, Typography, InputAdornment, OutlinedInput } from '@mui/material';
import { IconMagic } from '@qb/frontend/components/OmniSearch/_components/IconMagic';
import { useDebouncedQuery } from '@qb/frontend/hooks/useDebouncedQuery';
import { CategoryCard } from '@/global/pages/Search/Category/_components/CategoryCard';
import { SPSPartCategoryAllCategoriesResponse } from '@/shared/types/controllers/sps/SPSPartCategoryControllerTypes';
import { GetManufacturerSearchDataResponse } from '@/shared/types/controllers/sps/SPSSearchControllerTypes';
type CategoryCardsSearchProps = {
  allCategories: SPSPartCategoryAllCategoriesResponse['allPartCategories'];
  tenantAlias: string;
  hasSearchInput?: boolean;
  manufacturer?: GetManufacturerSearchDataResponse['manufacturer'];
};
export const CategoryCardsSearch = ({
  allCategories,
  tenantAlias,
  hasSearchInput = true,
  manufacturer
}: CategoryCardsSearchProps) => {
  const {
    setQuery,
    debouncedQuery
  } = useDebouncedQuery('', 200);
  const filteredCategories = useMemo(() => {
    return allCategories.filter(category => {
      if (debouncedQuery === '') {
        return true;
      }
      return category.name.toLowerCase().includes(debouncedQuery.toLowerCase());
    });
  }, [allCategories, debouncedQuery]);
  return <>
      <Stack data-sentry-element="Stack" data-sentry-source-file="CategoryCardsSearch.tsx">
        {hasSearchInput && <OutlinedInput placeholder="Search by category" aria-label="Search by category" size="small" fullWidth startAdornment={<InputAdornment sx={{
        pl: 0.5,
        mr: 0
      }} position="start">
                <SearchIcon color="primary" />
              </InputAdornment>} endAdornment={<IconMagic sx={{
        width: 40
      }} />} inputProps={{
        sx: {
          pl: 1,
          '&::placeholder': {
            color: 'text.secondary'
          }
        },
        type: 'search',
        enterKeyHint: 'search'
      }} sx={{
        bgcolor: 'common.white',
        pl: 1,
        mb: 3,
        '&.MuiOutlinedInput-root': {
          pr: 0
        }
      }} onChange={e => setQuery(e.target.value)} />}
      </Stack>
      <Grid2 container spacing={2} sx={{
      mt: 0
    }} data-sentry-element="Grid2" data-sentry-source-file="CategoryCardsSearch.tsx">
        {filteredCategories.length === 0 && <Grid2 size={12}>
            <Typography>No results for your search query.</Typography>
          </Grid2>}
        {filteredCategories.map(category => <CategoryCard category={category} key={category.id} tenantAlias={tenantAlias} manufacturer={manufacturer} />)}
      </Grid2>
    </>;
};